import request from '@/config/axios'

export interface AiUsageTenantSummaryVO {
  activeUserCount: number
  usageCount: number
  totalTokens: number
}

export interface AiUsageUserVO {
  userId: number
  nickname: string
  usageCount: number
  totalTokens: number
  lastUseTime?: Date
}

export interface AiUsageOrderVO {
  requestId: number
  createTime?: Date
  modelName?: string
  status?: string
  totalTokens?: number | null
}

/** AI 用量统计（本租户账号） */
export const AiUsageApi = {
  getTenantSummary: async (params: any) => {
    return await request.get({ url: '/ai/usage/tenant-summary', params })
  },
  getUserUsagePage: async (params: any) => {
    return await request.get({ url: '/ai/usage/user/page', params })
  },
  getUserOrderPage: async (params: any) => {
    return await request.get({ url: '/ai/usage/user/orders', params })
  }
}
